import React, { Fragment, useState } from "react";
import { useLocation } from "react-router-dom";
import useAuth, { apiResponse, authData } from "../context/AuthProvider";
import { Alert, Box, LinearProgress, TextField, Dialog, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { config } from "../Constants";
import { Field, Form, Formik } from "formik";
import { LoginModel_VS } from "../models/LoginModel";
import { CustomInputComponent, CustomInputComponentPassword } from "../components/Elements/input";
import Swal from "sweetalert2";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { apiClient } from "../helper/api";
import { buttonColors } from "../helper/theme";
import backgroundImage from "../assets/bg.jpg";
import logo from "../assets/MISC_Full_Type_Lockup_Secondary.png";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SendIcon from '@mui/icons-material/Send';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
interface Values {
  email: string;
  password: string;
}

export const LoginPage = () => {
  const { login, error } = useAuth();
  const [loading, setloading] = useState(false);
  const [showpassword, setshowpassword] = React.useState<boolean>(false);
  const { user } = useAuth();
  const token = user?.token;
  const location = useLocation();
  const returnTo = (location.state as any)?.from
    ? `${(location.state as any).from.pathname}${(location.state as any).from.search ?? ''}`
    : undefined;

  const handleLogin = (resp: apiResponse<authData>) => {
    login(resp, returnTo);
  };
  //  const handleLogin = (resp: { status: boolean; message: string; data: authData }) => {
  //   login(resp);
  // };

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const openForgotPasswordDialog = () => {
    setIsDialogOpen(true);
  };

  const closeForgotPasswordDialog = () => {
    setIsDialogOpen(false);
    setSelectedEmail("");
  };

  const [selectedEmail, setSelectedEmail] = useState("");

  const sendResetEmail = (email: string) => {
    setloading(true);
    if (selectedEmail.trim() === "") {
      alert("Please select an email");
      setloading(false);
      return;
    }
    apiClient(`/Auth/Users/checkEmailForForgetPassword?email=${email}`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          // 'Authorization': `Bearer ${token}`,
        }),
      }
    )
      .then((responseJson) => {
        if (!responseJson) return
        closeForgotPasswordDialog();
        console.log("emaildata", responseJson);
        if (responseJson.resp == 0) {
          Swal.fire({
            icon: "success",
            title: "Email Sent!",
            text: "Password reset instructions have been sent to your email.",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Email Not Found",
            text: "The provided email does not exist in our records.",
          });
        }
        setloading(false);
      })
      // .catch((error) => {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Error",
      //     text: "Something went wrong while processing your request.",
      //   });
      //   console.error(error);
      // });
  };

  const [showPassword, setShowPassword] = useState(false);

  return (
    <React.Fragment>
      {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
      <div style={{
            minHeight: '100vh',
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
        }}>
          <div className="container-fluid">
            <div className="row justify-content-center h-100">
              {/* Left side - Background with text */}
              <div className="col-6 col-sm-5 col-md-6 col-lg-6 col-xl-6 d-none d-sm-block">
                  <div className="p-xxl-5 p-xl-3 p-md-2 p-2 h-100 d-flex align-items-center justify-content-center">
                      <div className={`col-xxl-9 col-md-12 mx-auto text-white p-5 px-sm-2 pb-4`}>
                          <h4 className="fw-bolder mb-2">Comprehensive Support to Guide You Through the Surplus Lines Insurance Process</h4>
                          <p className="fw-light lh-sm" style={{fontSize: '0.85rem', width: '80%'}}>Our goal is to simplify compliance and help agents achieve success with confidence.</p>
                      </div>
                  </div>
              </div>
              {/* Right side - Login Form */}
              <div className="col-12 col-sm-7 col-md-6 col-lg-6 col-xl-6 px-xxl-18 px-xl-14 px-lg-10 px-md-8 px-sm-4 px-5 d-flex flex-column justify-content-center bg-white pt-5 d-sm-flex">
                <div className="mb-4">
                    <div className="mb-7">
                        <img src={logo} alt="MISC Logo" style={{width: '200px'}} className="img-fluid" />
                    </div>
                    <h2 className="text-primary">Welcome back!</h2>
                    <p className="text-muted">Please sign in to continue.</p>
                    <Formik
                      initialValues={{ Username: "", password: "" }}
                      validationSchema={LoginModel_VS}
                      validateOnChange={true}
                      onSubmit={(data, { setSubmitting }) => {
                        setloading(true);

                        apiClient("/Auth/login", {
                          method: "POST",
                          headers: new Headers({
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          }),

                          body: JSON.stringify(data), // <-- Post parameters
                        })
                          .then((res) => {
                            if (!res) return
                            // Do something with the response
                            setloading(false);
                            handleLogin(res);
                            setSubmitting(false);
                          })
                          .catch(() => {})
                          .finally(() => {
                            setloading(false)
                          })
                      }}
                    >
                      {({ submitForm, isSubmitting }) => (
                        <Form className="loginpage-samespace">
                          {/* Fixed-height strip: alert is absolutely positioned so username/password never shift when error toggles */}
                          <Box
                            sx={(theme) => ({
                              position: "relative",
                              flexShrink: 0,
                              height: `calc(${theme.spacing(6)} + 3.75rem + ${theme.spacing(1.875)})`,
                            })}
                          >
                            <Alert
                              severity="error"
                              role={error ? "alert" : undefined}
                              aria-hidden={!error}
                              sx={(theme) => ({
                                position: "absolute",
                                left: 0,
                                right: 0,
                                top: theme.spacing(6),
                                margin: 0,
                                visibility: error ? "visible" : "hidden",
                                pointerEvents: error ? "auto" : "none",
                                py: 1.5,
                                px: 2.25,
                                alignItems: "center",
                                borderRadius: 2,
                                backgroundColor: "rgba(220, 53, 69, 0.12)",
                                color: "#9e2a2f",
                                border: "1px solid rgba(220, 53, 69, 0.35)",
                                "& .MuiAlert-icon": {
                                  color: buttonColors.danger,
                                  padding: 0,
                                  mr: 1.5,
                                  fontSize: "1.35rem",
                                },
                                "& .MuiAlert-message": {
                                  padding: 0,
                                  width: "100%",
                                  fontSize: "1.05rem",
                                  lineHeight: 1.5,
                                },
                              })}
                            >
                              Incorrect login/password
                            </Alert>
                          </Box>
                          <div className="text-fields" style={{ marginTop: 0 }}>
                          <label className="form-label">User Name / Email</label>
                            <Field
                              className="form-control text-input"
                              component={CustomInputComponent}
                              type="text"
                              label="Username"
                              name="Username"
                              placeholder="Enter your user name or email"
                            />
                          </div>
                          <div className="forgot-password-section">
                            <label className="form-label">Password</label>
                            <Field
                              component={CustomInputComponent}
                              label="Password"
                              name="password"
                              id="password"
                              type={showPassword ? 'text' : "password"}
                              className="form-control text-input"
                              placeholder="Enter your password"

                            />
                            <div className="show-hide-password">
                              <a href="#" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <VisibilityIcon style={{ color: "#1789ca" }} /> : <VisibilityOffIcon style={{ color: "#1789ca" }} />}
                              </a>
                            </div>
                            <div className="forget-password">
                              <a href="#" onClick={openForgotPasswordDialog}>
                                Forgot Password?
                              </a>
                            </div>
                          </div>
                          <Dialog
                            open={isDialogOpen}
                            onClose={closeForgotPasswordDialog}
                            fullWidth
                            maxWidth="sm"
                            sx={{ '& .MuiDialog-paper': { borderRadius: "12px !important", overflow: "hidden", position: "relative" } }}
                          >
                            {loading && (
                              <LinearProgress sx={{ backgroundColor: "#132D3D", position: "absolute", top: 0, left: 0, right: 0, zIndex: 2 }} />
                            )}
                            <DialogTitle
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 2,
                                pr: 1,
                                py: 2,
                                background: "linear-gradient(135deg, #0d4a63 0%, #15607a 100%)",
                                color: "#fff",
                              }}
                            >
                              <Typography component="span" variant="subtitle1" sx={{ fontWeight: 600, textAlign: "left" }}>
                                Forgot password
                              </Typography>
                              <IconButton
                                onClick={closeForgotPasswordDialog}
                                size="small"
                                aria-label="Close"
                                sx={{
                                  color: "rgba(255,255,255,0.95)",
                                  "&:hover": { bgcolor: "rgba(255,255,255,0.15)", color: "#fff" },
                                }}
                              >
                                <CloseOutlinedIcon />
                              </IconButton>
                            </DialogTitle>
                            <DialogContent sx={{ pt: 3, pb: 2, px: 3, textAlign: "left" }}>
                              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Enter the email address for your account. We will send reset instructions.
                              </Typography>
                              <Field
                                className="form-control text-input"
                                component={CustomInputComponent}
                                type="text"
                                label="Email address"
                                name="email"
                                placeholder="Enter your email address"
                                value={selectedEmail}
                                onChange={(e: any) => setSelectedEmail(e.target.value)}
                              />
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ textAlign: "center", width: "100%", marginTop: "20px" }}
                                endIcon={<SendIcon fontSize="small" />}
                                onClick={() => sendResetEmail(selectedEmail)}
                                disabled={isButtonDisabled}
                                size="large"
                                sx={{ backgroundColor: "#1789ca", textTransform: 'none', transition: "background-color 0.3s ease", '&:hover': { backgroundColor: "#3a9bd2" }, '&:active': { borderRadius: "5px !important" }, mb: 1 }}
                              >
                                Send Reset Email
                              </Button>
                            </DialogContent>
                          </Dialog>
                          <Button
                            variant="contained"
                            color="primary"
                            style={{ textAlign: "center" }}
                            className="btn btn-primary w-100 py-2 mb-3"
                            type="submit"
                            size="large"
                            endIcon={<ArrowForwardIcon fontSize="small" />}
                            sx={{ backgroundColor: "#1789ca", textTransform: 'none', transition: "background-color 0.3s ease", '&:hover': { backgroundColor: "#3a9bd2" }, '&:active': { borderRadius: "5px !important" } }}
                          >
                            Sign In
                          </Button>
                          {/* <div className="terms-privacy">
                      <span>Terms&nbsp;&nbsp;|&nbsp;&nbsp;Privacy&nbsp;&nbsp;|&nbsp;&nbsp;Security&nbsp;&nbsp;|&nbsp;&nbsp;Get in Touch  </span>
                      </div> */}
                        </Form>
                      )}
                    </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      {/* Sign In
      
                </Button>


              </Form>
            )}
          </Formik>
        </div>


      </section> */}

    </React.Fragment>
  );
};
